<template>
<div>
<h1> Options </h1>
<hr style='width: 100%'>
<h2> Configure color scheme </h2>
<div class='override-class' style='{ margin: "20px"}'>
    <v-container fluid>
      <v-col cols='6'>
        <v-select
        :items="['light']"
        v-model='colorscheme'
        label='Select'
        selected="light"
        persistent-hint
        return-object
        single-line
        outlined
        v-on:change='change_color_scheme()'
        ></v-select>
      </v-col>
    </v-container>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    change_color_scheme () {
      /// Currently only light color-schemed supported
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/OptionsComponent.vue